import { Button, Image, VStack } from '@chakra-ui/react';
import SocialLogin from './social_login';
import util from './social_utils';

const SocialBtns = () => {
  const login = new SocialLogin();

  let isClicked = false;

  const socialLogin = [
    {
      name: '카카오',
      bg_color: '#fee500',
      txt_color: '#191600',
      icon: 'icn_login_kakaotalk',
      onClick: (e: any) => {
        e.preventDefault();

        clickBtn('kakao');
      },
    },
    {
      name: '네이버',
      bg_color: '#03c75a',
      txt_color: '#ffffff',
      icon: 'icn_login_naver',
      onClick: (e: any) => {
        e.preventDefault();

        clickBtn('naver');
      },
    },
  ];

  const clickBtn = async (type: string) => {
    if (isClicked) {
      return;
    } else {
      isClicked = true;
      util.delay(1000).then(() => {
        isClicked = false;
      });
    }

    switch (type) {
      case 'kakao':
        login.kakaoLogin();
        break;
      case 'naver':
        login.naverLogin();
        break;
    }
  };

  return (
    <>
      <div className="div_social">
        <VStack spacing={'10px'}>
          {socialLogin.map((e, i) => {
            return (
              <Button
                pos={'relative'}
                key={e.name}
                colorScheme={'black_button'}
                w={'100%'}
                h="56px"
                borderRadius={'2px'}
                bg={e.bg_color}
                textColor={e.txt_color}
                fontSize={'15px'}
                fontWeight="medium"
                onClick={e.onClick}>
                <Image
                  src={`/assets/images/${e.icon}.svg`}
                  pos={'absolute'}
                  boxSize={'15px'}
                  left="18px"
                />
                {e.name}로 시작하기
              </Button>
            );
          })}
        </VStack>
      </div>
      <div id="naverIdLogin" style={{ display: 'none' }} />
    </>
  );
};

export default SocialBtns;
